// @ts-nocheck
import React, { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import { ModalGeneral } from "../../Componentes/ModalGeneral";
import { Visibility } from '@mui/icons-material';
import VerRolesUser from "./VerRolesUser";
import useMediaQuery from '@mui/material/useMediaQuery';

export default function UserItem({ user }) {

    const [openModalVer, setOpenModalVer] = useState(false);
    const matches = useMediaQuery('(min-width:800px)');

    const handleOpenDetails = () => {
        setOpenModalVer(true);
    }

    const onClose = () => {
        setOpenModalVer(false);
    };

    return (
        <>
            <ListItem
                sx={{
                    borderRadius: '30px',
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: '#f0f0f0',
                    },
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "20px"
                }}
                onClick={() => handleOpenDetails()}
            >
                <div>
                    <Typography
                        sx={{
                            display: 'block',
                            whiteSpace: 'normal',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            maxWidth: matches ? '400px' : '200px',
                            fontSize: "20px",
                            color: "textPrimary"
                        }}

                    >
                        <strong>{user.username}</strong> | {user.firstName} {user.lastName}
                    </Typography>

                    <Typography
                        sx={{
                            display: 'block',
                            whiteSpace: 'normal',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            maxWidth: matches ? '400px' : '200px',
                            fontSize: "14px",
                            color: "textSecondary"
                        }}

                    >
                        {user.email}
                    </Typography>
                </div>
                <Tooltip title="Ver Roles Asignados">
                    <IconButton onClick={handleOpenDetails} size="large">
                        <Visibility color="primary" />
                    </IconButton>
                </Tooltip>
            </ListItem>

            <ModalGeneral
                Contenido={<VerRolesUser user={user} />}
                open={openModalVer}
                onClose={onClose}
            />
        </>
    );
}